import { findIndex } from 'lodash';

export const isAddedToFavorite = (listFavorites: string[], menuId: string): boolean => {
  return findIndex(listFavorites, (id: string) => id === menuId) !== -1 ? true : false;
};
